import React from 'react';
import { NudosButton, NudosTextInput } from '../../../../../../components/NudosComponents';
import ConfigClassSelector from '../../../../../../components/ToolConfigurationsSection/Components/AddSettingsModal/ConfigClassSelector/ConfigClassSelector';
import ConfigFieldsForm from '../../../../../../components/ToolConfigurationsSection/Components/AddSettingsModal/ConfigFieldsForm/ConfigFieldsForm';
import { IConfigClass } from '../../../../../../constants/configurations.constants';
import { IorganizationBusinessData } from '../../../../../../types/bussines';
import { CONFIG_CLASS_ID } from '../../../../../../types/product.configuration.types';

const AddConfigModalContent = ({
  organizationData,
  configClassIds,
  selectedConfigClassId,
  handleConfigClassSelection,
  configurationNameField,
  setConfigurationNameField,
  selectedConfigClass,
  formValues,
  setFormValues,
  setIsFormValid,
  handleSubmit,
  isButtonDisabled
}: {
  organizationData: IorganizationBusinessData;
  configClassIds: CONFIG_CLASS_ID[];
  selectedConfigClassId: CONFIG_CLASS_ID;
  handleConfigClassSelection: (classId: CONFIG_CLASS_ID) => void;
  configurationNameField: string;
  setConfigurationNameField: (value: string) => void;
  selectedConfigClass: IConfigClass | null;
  formValues: Record<number, string | File>;
  setFormValues: React.Dispatch<React.SetStateAction<Record<number, string | File>>>;
  setIsFormValid: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmit: () => void;
  isButtonDisabled: boolean;
}) => {
  return (
    <div className="addConfigModalContent">
      <div className="overflow-y-auto">
        <div className="addConfigModalSubtitle">
          Crea una nueva configuración para la empresa {organizationData.businessName}
        </div>

        <div className="addConfigModalFieldsContainer">
          <ConfigClassSelector
            configClassIds={configClassIds}
            selectedConfigClassId={selectedConfigClassId}
            onClassSelection={handleConfigClassSelection}
          />

          {selectedConfigClass && (
            <>
              <div className="mt-16">
                <NudosTextInput
                  label="Nombre de la configuración"
                  defaultValue={configurationNameField}
                  handleChange={setConfigurationNameField}
                  placeholder="Nombre de la configuración"
                  isFilled
                />
              </div>
              <ConfigFieldsForm
                selectedConfigClass={selectedConfigClass}
                formValues={formValues}
                setFormValues={setFormValues}
                setIsFormValid={setIsFormValid}
                showAlert={false}
              />
            </>
          )}
        </div>
      </div>

      <div className="addConfigModalButtonContainer">
        <NudosButton
          buttonText="Agregar configuración"
          customHeight="38px"
          customWidth="180px"
          handleClick={handleSubmit}
          isButtonDisabled={isButtonDisabled}
        />
      </div>
    </div>
  );
};

export default AddConfigModalContent;
